import {UserAccount} from '../../__generated__/resolvers-types';
import {FeatureObject} from '../../types/FeatureObject';
import {FeatureStatus} from '../../types/FeatureStatus';
import {filterByExcludeStatus} from './filterByExcludeStatus';

/**
 * Filter features for non-owner users
 * - show all features if user is owner
 * - show all features except alpha and admin if user is not owner
 * @param user
 * @returns
 */
export function filterForOwner(user?: UserAccount | null): (f: FeatureObject) => boolean {
  return (f) =>
    user?.permissions?.includes('owner') || filterByExcludeStatus([FeatureStatus.ALPHA, FeatureStatus.ADMIN])(f);
}
